import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play-circle",
  "use": "play-circle-usage",
  "viewBox": "0 0 68 68",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 68\" id=\"play-circle\">\n    <circle cx=\"34\" cy=\"34\" r=\"34\" fill=\"#000\" opacity=\".5\" />\n    <path fill=\"#FFF\" d=\"M45.185 35.033L29.87 46.265a2 2 0 0 1-3.182-1.613V22.19a2 2 0 0 1 3.182-1.613l15.316 11.232a2 2 0 0 1 0 3.225z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol